<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Transport de colis et de marchandises et Location de bus et de camion" />
            <ProduitTransportLocation />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProduitTransportLocation from '../Services/ProduitTransportLocation'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProduitTransportLocationPage',
    components: {
        NavBar,
        PageTitle,
        ProduitTransportLocation,
        FooterComp,
    }
}
</script>